import { PageLayout } from "@/components/PageLayout";
import { PageHero, SectionCTA } from "@/components/PageHero";
import { About as AboutSection } from "@/components/About";

const About = () => (
  <PageLayout testId="about-page">
    <PageHero
      eyebrow="Our Story"
      title="Born In"
      accent="Pine Hill"
      breadcrumb="About"
      subtitle="11 years deep — from a Memphis food-stand on Gaither to a brick-and-mortar on Lamar Ave and now West Memphis, Arkansas. Family-run, fresh every order, the Cole Squad."
      bg="/assets/team/cole-owners.jpg"
    />
    <AboutSection />
    <section className="bg-[#1A1A1A] border-t border-[#222] py-14">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h3 className="font-heading text-3xl sm:text-4xl text-white mb-6">
          Soulful Living, Served <span className="text-[#E60000]">Hot</span>
        </h3>
        <div className="flex flex-wrap justify-center gap-3">
          <SectionCTA to="/menu" label="See The Menu" />
          <SectionCTA to="/gallery" label="See Our Food" />
        </div>
      </div>
    </section>
  </PageLayout>
);

export default About;
